module.exports = __webpack_public_path__ + "static/img/map-pic.8a8ea1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/map-pic.png
// module id = cyN3
// module chunks = 9